import React, { useEffect, useState } from "react";
import { Styles } from "../../../../../config/design/styles";
import { connect } from "trim-redux";
import axios from "axios";
import { defaultVariables } from "../../../../../config";
import { Autocomplete } from "@mui/lab";
import { withStyles } from "@mui/styles";
import { CircularProgress } from "@mui/material";
import { translateKey } from "../../../../../config/values";
import RayaField from "../../../../components/elements/fields/RayaField";

const ShopChooser = (props) => {
    const {
        selected: initialSelected,
        default_id,
        shop_id,
        industry,
        handleRes,
        required,
        error,
        locale,
        size,
        disabled,
    } = props;

    const [categories, setCategories] = useState([]);
    const [selected, setSelected] = useState(initialSelected || null);
    const [loading, setLoading] = useState(true);
    const [open, setOpen] = useState(false);

    const loadData = async () => {
        setLoading(true);
        try {
            const loginToken = localStorage.getItem("ACT");
            const config = {
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${loginToken}`,
                },
            };
            const response = await axios.get(
                `${defaultVariables.url}/shops/get-all${industry ? "/" + industry : ""}`,
                config
            );

            const data = response.data;
            let selectedItem = null;
            if (default_id) {
                selectedItem = data.find((item) => parseInt(item.id) === parseInt(default_id));
                if (selectedItem) {
                    handleType(selectedItem);
                }
            }

            setCategories(data);
        } catch (error) {
            console.log(error.response);
        } finally {
            setLoading(false);
        }
    };

    const handleType = (data) => {
        handleRes(data);
        setSelected(data);
    };

    useEffect(() => {
        loadData();
    }, [industry]); // Re-fetch when `industry` changes

    return (
        <Autocomplete
            fullWidth
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            required={required}
            getOptionLabel={(option) => option.name}
            onChange={(event, value) => handleType(value)}
            options={categories}
            value={selected}
            loading={loading}
            size={size || ""}
            disabled={disabled}
            renderInput={(params) => (
                <RayaField
                    {...params}
                    label={translateKey("shop")}
                    variant="outlined"
                    required={required}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                    error={error}
                    helperText={error || ""}
                />
            )}
        />
    );
};

const mstp = (state) => ({
    isAuth: state.isAuth,
    user: state.user,
    locale: state.locale,
});

export default withStyles(Styles)(connect(mstp)(ShopChooser));
